import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Badge,
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { Link } from 'react-router-dom';
import { RoutesFun } from '../../../schemas';
import './awsManual.css';

// Define props for the OptionCard component
interface OptionCardProps {
  title: string;
  description: string;
  Icon: React.ElementType;
  recommended?: boolean;
  onClick?: () => void;
}

const OptionCard: React.FC<OptionCardProps> = ({
  title,
  description,
  Icon,
  onClick,
}) => {
  return (
    <Badge
      badgeContent={null}
      color="primary"
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      sx={{ width: '100%', cursor: 'pointer' }}
      onClick={onClick}
    >
      <Card
        sx={{
          textAlign: 'center',
          p: 2,
          borderRadius: 2,
          boxShadow: 2,
          width: '100%',
        }}
      >
        <CardContent>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              mb: 1,
            }}
          >
            <Icon
              sx={{
                fontSize: 50,
                color: 'primary.main',
                background: '#b5d4e1',
                fill: '#1782ab',
                borderRadius: '50%',
                padding: '0.2em',
                width: '1.5em',
                height: '1.5em',
              }}
            />
          </Box>
          <Typography
            variant="h5"
            fontWeight="bold"
            sx={{ mt: 2, mb: 2, fontSize: '1.75rem' }}
          >
            {title}
          </Typography>
          <Typography variant="h6" color="text.secondary">
            {description}
          </Typography>
          <Button
            variant="text"
            sx={{
              mt: 2,
              fontSize: 18,
              textTransform: 'none',
              background: 'rgb(97 158 219 / 20%)',
              borderRadius: '50%',
              height: 40,
              width: 40,
              minWidth: 40,
            }}
          >
            →
          </Button>
        </CardContent>
      </Card>
    </Badge>
  );
};

interface SelectionProps {
  onSelect: (cardType: string) => void;
}

const SelectionCard: React.FC<SelectionProps> = ({ onSelect }) => {
  return (
    <Grid container spacing={2} justifyContent="center">
      <Grid item xs={12} sm={6}>
        <Link to={RoutesFun().CreateAutomationAccount}>
          <OptionCard
            title="Automated"
            description="Run a CloudFormation template"
            Icon={SettingsIcon}
            recommended
            onClick={() => onSelect('automated')}
          />
        </Link>
      </Grid>
      <Grid item xs={12} sm={12}>
        <Grid item xs={12} sm={12} sx={{ textAlign: 'center' }}>
          <Typography variant="body1" gutterBottom style={{ fontWeight: 600 }}>
            - or -
          </Typography>
          <Typography variant="body2" gutterBottom>
            <Link
              className="manualSetupLink"
              to={RoutesFun().CreateManualAccount}
            >
              click for manual setup
            </Link>
          </Typography>
        </Grid>
        {/* <OptionCard
          title='Manual'
          description='Follow step-by-step instructions'
          Icon={TouchAppIcon}
          onClick={() => onSelect('manual')}
        /> */}
      </Grid>
    </Grid>
  );
};

export default SelectionCard;
